import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "alarms" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "first-column-with-icon-type" }
const _hoisted_6 = { class: "name-type-block" }
const _hoisted_7 = { class: "type-data-block" }
const _hoisted_8 = {
  key: 0,
  class: "type-data-block"
}
const _hoisted_9 = { class: "emq-table-footer" }

import PreWithEllipsis from '@/components/PreWithEllipsis.vue'
import { alarmRepositoryList } from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { constant, pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { ElMessage, ElMessageBox } from 'element-plus'
import AlarmLevel from '@/components/AlarmLevel.vue'
import AlarmType from '@/components/AlarmType.vue'
import AlarmsRepositoryUpsert from './components/AlarmsRepositoryUpsert.vue'
import { checkMenuShow } from '@/store/tool'

import { dateFormat } from '@/common/tools'


import { defineComponent, ref } from 'vue'

const __default__ = defineComponent({
  name: 'AlarmsRepository',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18nTl('Operation')

const showData = ref({})
const showDialog = ref(false)
const edidDialog = ref(false)
const showMoreQuery = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { getEvseProtocolDesc } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('evses-detail')

const editARDialog = (row: any) => {
  showData.value = row
  edidDialog.value = true
  showDialog.value = true
}

const addARDialog = () => {
  showData.value = {}
  edidDialog.value = false
  showDialog.value = true
}

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadDatas()
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { id, operatorID, sn } = params
  newParams = {
    id: id || undefined,
    operatorID: operatorID || undefined,
    sn: sn || undefined,
  }
  return newParams
}

const loadDatas = async () => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
    },
  }

  try {
    const { list = [], pageReply = {} } = await alarmRepositoryList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}

loadDatas()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (addARDialog()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'evseARUpsert']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: loadDatas
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "alarmName",
            "min-width": "80",
            label: _ctx.$t('Base.name'),
            show: "false",
            align: "center",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_tooltip, {
                placement: "top",
                content: row.id
              }, {
                default: _withCtx(() => [
                  _createVNode(PreWithEllipsis, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.alarmName), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["content"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "protocol",
            "min-width": "50",
            label: _ctx.$t('Evses.evseProtocol'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(getEvseProtocolDesc)(row.protocol)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "alarmCode",
            "min-width": "100",
            label: _ctx.$t('Evses.alarmCode'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(row.alarmCode), 1),
                  (row.subAlarmCode != '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(row.subAlarmCode), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "type",
            "min-width": "80",
            label: _ctx.$t('Evses.alarmType'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(AlarmType, {
                state: row.type
              }, null, 8, ["state"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "level",
            "min-width": "80",
            label: _ctx.$t('Evses.alarmLevel'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(AlarmLevel, {
                state: row.level
              }, null, 8, ["state"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "solution",
            "min-width": "150",
            label: _ctx.$t('Base.solution'),
            show: "false"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "updatedAt",
            "min-width": "80",
            label: _ctx.$t('Base.updatedAt'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(Number(row.updatedAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (editARDialog(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'evseARUpsert']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[1] || (_cache[1] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadDatas
        }, null, 8, ["metaData"])
      ]),
      _createVNode(AlarmsRepositoryUpsert, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showDialog).value = $event)),
        isEdit: edidDialog.value,
        info: showData.value,
        onSubmitted: loadDatas
      }, null, 8, ["modelValue", "isEdit", "info"])
    ])
  ]))
}
}

})